export default {
  chartData: [],
  queryData: null,
  benchmarkCohortData: null,
  segmentDashboardData: null
};
